import initialState from "./initialState";

const mutations = {
  setErrors: (state, errors) => (state.errors = errors),
  setIsPaymentSuccess: (state, status) => (state.isPaymentSuccess = status),
  changeUpgradeButtonVisibilityStatus: (state, status) => (state.upgradeButtonVisibilityStatus = status),
  resetModule:(state)=>(Object.assign(state,initialState()))
};

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/payment/mutations.js